


































import { Vue, Component, Prop } from 'vue-property-decorator';
import { getAspectRatioFromUrl } from '@/common/ts/common';
import XcqManuscriptFooter from './XcqManuscriptFooter.vue';
import TopTag from './TopTag.vue';
import XcqImage from './XcqImage.vue';

@Component({
  components: {
    XcqManuscriptFooter,
    TopTag,
    XcqImage,
  },
})
export default class XcqManuscriptSmallImg extends Vue {
  @Prop({
    default: () => ({
      blockHeaderPic: '',
      blockName: '',
      blockBottomText: '',
      extText1: '',
      data: {},
      list: [],
    }),
  })
  blockInfo!: any;

  @Prop({ default: 349 }) width!: number;

  @Prop({ default: null }) blockDataInfo!: any;

  @Prop({ default: false }) showTop!: boolean;

  @Prop({ default: 0 }) topValue!: number;

  get dataInfo(): any {
    return this.blockDataInfo || this.blockInfo.data;
  }

  get imgWidth(): number {
    return this.width;
  }

  getTopImgHeight(url: any): number {
    const ratio = getAspectRatioFromUrl(url) || 1.78;
    return Math.round(this.imgWidth / ratio);
  }

  handleClick(info: any): void {
    this.$emit('clickItem', info.jump, info);
  }
}
